<div class="cust-height">
  <div class="col-12 md:col-12">
    <p-table
      #dt
      [(selection)]="selectedRows"
      selectionMode="multiple"
      [columns]="listColumns"
      [value]="batchList"
      [rows]="100"
      [paginator]="true"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      >
      <ng-template pTemplate="caption">
        <span class="header-grid-wrapper">
          <span class="align-right">{{'Batch_Title' | translate}} {{'Tot' | translate}} {{ batchList.length }} {{'Batch_1' | translate}}</span>
        </span>
        <button pButton type="button" icon="icons8-trash-can" class="cust-width p-button-danger right margin"
          [disabled]="disabledDel===true && selectedRows.length === 0"
          pTooltip="{{'Batch_Delete' | translate}}"
          tooltipPosition="left"
          (click)="clickDelExpiredBatch()"
        ></button>
      </ng-template>
      <ng-template let-columns pTemplate="header">
        <tr>
          <th class="width-col-3">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          @for (col of columns; track col; let i = $index) {
            <th
              [pSortableColumn]="col.sort"
                        [ngClass]="{
                            'width-col-13': col.type === 'DateTime',
                            'width-auto': col.type !== 'DateTime',
                            'width-col-15': col.field === 'batchstate' || col.field === 'batchtype'
                        }"
              >
              @if (col.sort !== null) {
                <p-sortIcon [field]="col.sort"></p-sortIcon>
              }
              {{ col.header }}
              @if (col.field === 'batchstate') {
                <p-dropdown
                  appendTo="body"
                  [options]="stateList"
                  [style]="{ width: '100%' }"
                  (onChange)="dt.filter($event.value, col.field, 'equals')">
                  <ng-template let-stateList pTemplate="item">
                    @switch (stateList.value) {    
                      @case (0) {
                        <i class="pi pi-clock md-18" style="color: green"></i>
                      }
                      @case (1) {
                        <i class="pi pi-hourglass md-18" style="color: green"></i>
                      }
                      @case (2) {
                        <i class="pi pi-check md-18" style="color: green"></i>
                      }
                      @case (3) {
                        <i class="pi pi-times md-18" style="color: red"></i>
                      }
                      @case (4) {
                        <i class="pi pi-file-import md-18" style="color: green"></i>
                      }
                      @case (5) {
                        <i class="pi pi-hourglass md-18" style="color: red"></i>
                      }
                    }
                    {{stateList.label}}
                  </ng-template>
                </p-dropdown>
              }
              @if (col.field === 'batchtype') {
                <p-dropdown
                  appendTo="body"
                  [options]="typeList"
                  [style]="{ width: '100%' }"
                  (onChange)="dt.filter($event.value, col.field, 'equals')">
                  <ng-template let-batchtype pTemplate="item">
                    @switch (batchtype.value) {    
                      @case (0) {
                        <i class="icons8-statistiques md-18"></i>
                      }
                      @case (1) {
                        <i class="icons8-pdf md-18"></i>
                      }
                      @case (2) {
                        <i class="icons8-versions md-18"></i>
                      }
                      @case (3) {
                        <i class="icons8-exporter md-18"></i>
                      }
                      @case (4) {
                        <i class="icons8-exporter md-18"></i>
                      }
                    }
                    {{batchtype.label}}
                  </ng-template>
                </p-dropdown>
              }
              @if (col.field !== 'batchtype' && col.field !== 'batchstate') {
                <input
                  (click)="$event.stopPropagation()"
                  pInputText
                  type="text"
                  (input)="dt.filter($event.target.value, col.field, 'contains')"
                  style="color: darkgrey"
                  />
              }
            </th>
          }
          <th style="width: 3em"></th>
        </tr>
      </ng-template>
      <ng-template let-rowData let-columns="columns" pTemplate="body">
        <tr [pSelectableRow]="rowData">
          <td (click)="clickcolck($event)">
            <p-tableCheckbox [value]="rowData" [index]="rowIndex"></p-tableCheckbox>
          </td>
          @for (col of columns; track col; let i = $index) {
            <td class="width-auto">
              @switch (col.field) {
                @case ('datedem') {
                  <div class="align-left">
                    {{ rowData[col.field] | datelength | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </div>
                }
                @case ('dateexec') {
                  <div class="align-left">
                    {{ rowData[col.field] | datelength | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </div>
                }
                @case ('dateexpired') {
                  <div class="align-left">
                    {{ rowData[col.field] | datelength | datecompat | date: 'dd/MM/yyyy' }}
                  </div>
                }
                @case ('batchstate') {
                  <div class="align">
                    @switch (rowData[col.field]) {
                      @case (0) {
                        <i pTooltip="{{'Batch_State_0' | translate}}" class="pi pi-clock md-18" style="color: green"></i>
                      }
                      @case (1) {
                        <i pTooltip="{{'Batch_State_1' | translate}}" class="pi pi-hourglass md-18" style="color: green"></i>
                      }
                      @case (2) {
                        <i pTooltip="{{'Batch_State_2' | translate}}" class="pi pi-check md-18" style="color: green"></i>
                      }
                      @case (3) {
                        <i pTooltip="{{'Batch_State_3' | translate}}" class="pi pi-times md-18" style="color: red"></i>
                      }
                      @case (4) {
                        <i pTooltip="{{'Batch_State_4' | translate}}" class="pi pi-file-import md-18" style="color: green"></i>
                      }
                      @case (5) {
                        <i pTooltip="{{'Batch_State_5' | translate}}" class="pi pi-hourglass md-18" style="color: red"></i>
                      }
                    }                    
                  </div>
                }
                @case ('batchtype') {
                  <div class="align">
                    @switch (rowData[col.field]) {
                      @case (0) {
                        <i pTooltip="{{'Batch_Type_0' | translate}}" class="icons8-statistiques md-18"></i>
                      }
                      @case (1) {
                        <i pTooltip="{{'Batch_Type_1' | translate}}" class="icons8-pdf md-18"></i>
                      }
                      @case (2) {
                        <i pTooltip="{{'Batch_Type_2' | translate}}" class="icons8-versions md-18"></i>
                      }
                      @case (3) {
                        <i pTooltip="{{'Batch_Type_3' | translate}}" class="icons8-exporter md-18"></i>
                      }
                      @case (4) {
                        <i pTooltip="{{'Batch_Type_4' | translate}}" class="icons8-exporter md-18"></i>
                      }
                    }
                  </div>
                }
                @default {
                  <div>
                    {{ rowData[col.field] }}
                  </div>
                }
              }
            </td>
          }
          <td>
            @if (rowData['batchstate'] === 4) {
              <button
                class="cust-width p-button-success"
                type="button" pButton
                icon="pi icons8-t-l-charger"
                pTooltip="{{'DwnL' | translate}}"
                (click)="onDownLoad($event, rowData)"
              ></button>
            }
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">{{'Empty' | translate}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete()"></app-item-confirm>
